import { MessageCircle, Instagram, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, NAV_LINKS, PHONE_DISPLAY, WA_FLOAT } from "@/lib/constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-cob-dark text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/65">
            Cuidando da sua saúde desde 2004.
          </p>
          <span className="mt-5 block h-px w-14 bg-cob-gold/60" />
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-cob-gold">Navegação</p>
          <nav className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`footer-link-${link.href.slice(1)}`}
                className="text-sm text-white/70 transition-colors hover:text-cob-gold"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-cob-gold">Contato</p>
          <div className="mt-5 space-y-3.5 text-sm text-white/70">
            <a
              href={WA_FLOAT}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex items-center gap-2.5 transition-colors hover:text-cob-gold"
            >
              <MessageCircle className="h-4 w-4 text-cob-gold" /> {PHONE_DISPLAY}
            </a>
            <p className="flex items-center gap-2.5">
              <MapPin className="h-4 w-4 text-cob-gold" /> Teresina – PI | Zona Norte
            </p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-2.5 transition-colors hover:text-cob-gold"
            >
              <Instagram className="h-4 w-4 text-cob-gold" /> {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/50">
          © {new Date().getFullYear()} Clínica COB | Ortopedia e Fisioterapia. Todos os direitos reservados.
        </p>
        <a
          href="/admin"
          data-testid="footer-admin-link"
          className="text-xs font-medium text-white/40 transition-colors hover:text-cob-gold"
        >
          Área administrativa
        </a>
      </div>
    </div>
  </footer>
);
